<template>
  <div class="row form-group">
    <div class="col-md-12">
      <div class="d-flex justify-content-between">
        <label>
          <u>{{ $t('homework.referenceFile') }}</u>
        </label>
        <label
          class="btn btn-sm btn-flat-info btn-outline-info"
          for="referencefile"
          >{{ $t('homework.uploadFile') }}</label
        >
        <input
          type="file"
          id="referencefile"
          ref="referencefile"
          style="display:none"
          multiple
          @change="onReferenceFileChange"
        />
      </div>
      <table style="width:100%">
        <tr v-for="(refer, index) in referenceFiles" :key="index">
          <td
            style="width:55%"
            class="mt-2"
            :class="{ 'text-red': refer.invalid_file }"
          >
            {{ refer.name }}
          </td>
          <td style="width:10%" class="ts-whitespace-no-wrap">
            {{ refer.size }} KB
          </td>
          <td style="width:25%">
            <a-progress
              v-if="!refer.invalid_file"
              :percent="refer.progressing"
            ></a-progress>
          </td>
          <td class="text-center" style="width:10%">
            <a
              href="#"
              class="text-red"
              v-if="refer.progressing == 100"
              @click.prevent="onRemoveFile(index, refer)"
            >
              <i class="fa fa-times"></i>
            </a>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import httpClient from '@/http-client'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'trainingToolAttachmentFile',
  props: ['value'],
  data() {
    return {
      model: {},
      referenceFiles: []
    }
  },
  computed: {
    ...mapState('eschool/teacherHomework', ['edit_data']),
    isEdit() {
      return !_.isEmpty(this.edit_data) && this.edit_data !== undefined
    }
  },
  created() {
    this.model = this.value
    this.setEdit()
  },
  methods: {
    ...mapActions('eschool/teacherHomework', ['removeFileUploaded']),
    onReferenceFileChange(e) {
      let files = e.target.files
      this.referenceFiles = [
        ...this.referenceFiles,
        ..._.map(files, file => ({
          name: file.name,
          size: parseInt(file.size / 1024),
          type: file.type,
          progressing: 0,
          invalid_file: this.validate(file),
          file: file,
          uploaded: false,
          storage_path: null
        }))
      ]
      _.forEach(
        this.referenceFiles.filter(file => file.uploaded == false),
        (f, index) => {
          if (!this.validate(f.file)) {
            let frm = new FormData()
            frm.append('file', f.file)
            frm.append('file_type', 2)
            httpClient
              .post('/api/homework-upload-files', frm, {
                onUploadProgress: el => {
                  if (el.lengthComputable) {
                    f.progressing = Math.round((el.loaded * 100) / el.total)
                  }
                }
              })
              .then(response => {
                f.uploaded = true
                f.storage_path = response.data.attach_file_path
                this.model.attach_file_list.push(
                  Object.assign({}, response.data)
                )
              })
              .catch(error => {
                this.$toasted.error(error.message)
              })
          }
        }
      )
    },
    validate(file) {
      let ALLOW_FILE = [
        'image/png',
        'image/jpeg',
        'application/pdf',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.ms-powerpoint',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/msword'
      ]

      if (file.size > 10000000 * 10 || !ALLOW_FILE.includes(file.type)) {
        return true
      }

      return false
    },
    onRemoveFile(index, record) {
      this.removeFileUploaded({
        file_path: record.storage_path
      })
      this.referenceFiles.splice(index, 1)
      let file_index = this.model.attach_file_list.indexOf(
        ...this.model.attach_file_list.filter(
          f => f.attach_file_path == record.storage_path
        )
      )
      this.model.attach_file_list.splice(file_index, 1)
    },
    clearTrainingAttachFile() {
      this.referenceFiles = []
      this.$refs.referencefile.value = ''
    },
    setEdit() {
      if (this.isEdit) {
        this.referenceFiles = this.edit_data.homework_attachment
          .filter(att => att.attach_file_type == 2)
          .map(el => ({
            name: el.attach_file_name,
            size: 0,
            type: el.attach_file_mime_type,
            progressing: 100,
            invalid_file: false,
            file: null,
            uploaded: true,
            storage_path: el.attach_file_path
          }))
      }
    }
  }
}
</script>
